import React, { useState } from 'react';
import { Icon } from 'react-icons-kit';
import { eye } from 'react-icons-kit/feather/eye';

/**
 * Icône œil ouvrant un aperçu de l'écran correspondant dans l'application.
 * Un clic n'importe où sur l'overlay referme l'image.
 */
function AppDisplayPreview({ image, label = "Aperçu dans l'application" }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center justify-center w-10 h-10 rounded-full text-primary hover:bg-gray-100"
        aria-label={label}
        title={label}
      >
        <Icon icon={eye} size={22} />
      </button>
      {open ? (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 cursor-pointer"
          onClick={() => setOpen(false)}
          role="presentation"
        >
          <img
            src={image}
            alt={label}
            className="max-h-[90vh] max-w-[90vw] object-contain rounded-lg shadow-lg"
          />
        </div>
      ) : null}
    </>
  );
}

export default AppDisplayPreview;
